import axios from "axios";

import type { AuthUser } from "@/store/auth";
import { api } from "./client";

export interface LoginResult {
  access_token: string;
  refresh_token: string;
}

export interface LoginOTPRequired {
  otp_required: true;
  otp_token: string;
  token_type: "otp_pending";
}

export type LoginResponse = LoginResult | LoginOTPRequired;

export function isOtpRequired(r: LoginResponse): r is LoginOTPRequired {
  return (r as LoginOTPRequired).otp_required === true;
}

export async function login(username: string, password: string): Promise<LoginResponse> {
  // OAuth2 password flow — form-urlencoded
  const form = new URLSearchParams();
  form.append("username", username);
  form.append("password", password);
  const r = await axios.post<LoginResponse>("/api/v1/auth/login", form, {
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  });
  return r.data;
}

export async function fetchMe(): Promise<AuthUser> {
  const r = await api.get<AuthUser>("/auth/me");
  return r.data;
}

export async function register(payload: {
  username: string;
  password: string;
  role: AuthUser["role"];
  full_name?: string | null;
}): Promise<AuthUser> {
  const r = await api.post<AuthUser>("/auth/register", payload);
  return r.data;
}
